<template>
  <div>
    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">1. Question Font Size Settings:</label>
        <div style="display: flex; align-items: center;">
          <b-form-select style="width: 100px; margin-right: 5px;" v-model="zoomLevel" :options="zoomOptions"
            value-field="value" text-field="text" :disabled="!editZoomLevel"></b-form-select>

          <!-- Update button -->
          <button v-if="editZoomLevel" class="btn btn-success btn-sm mr-2" @click="setQuestionPaperZoomLevel()">
            Update
          </button>

          <!-- Cancel button -->
          <button v-if="editZoomLevel" class="btn btn-danger btn-sm mr-2" @click="cancelEditZoomLevel">
            Cancel
          </button>

          <!-- Edit icon -->
          <i v-if="!editZoomLevel && !usersubgroup_id" class="fas fa-edit text-info" style="font-size: 15px !important; cursor: pointer;"
            @click="enableZoomEdit"></i>
        </div>

        <span style="display: block; margin-top: 5px; zoom: zoomLevel;">
          "Preview Text: Check font size visibility."
        </span>
      </b-form-group>
    </b-row>
    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">2. Signature Field Settings:</label>
        <!-- Main Table for Signature Field Settings -->
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No</th>
              <th>Signature Field</th>
              <th>Signed Officials</th>
            </tr>
          </thead>
          <tbody>
            <!-- Looping through signature fields -->
            <tr v-for="(field, index) in signatureFields" :key="index">
              <td>{{ index + 1 }}</td> <!-- Displaying serial number -->

              <td class="d-flex align-items-center justify-content-between">
                <span>{{ formatFieldName(field.name) }}</span>
                <!-- + Icon to Add Role -->
                <i v-if="!usersubgroup_id" class="fas fa-plus-square text-primary" style="cursor: pointer; font-size: 16px;"
                  @click="addNewRoleAndSignatureField(field.name)">
                </i>
              </td>

              <td>
                <!-- Nested Table for Signed Officials -->
                <table class="table table-borderless">
                  <tbody>
                    <!-- Looping through signed officials for each field -->
                    <template v-for="(role, roleKey) in field.signed_officials">
                      <tr :key="roleKey">
                        <td style="width: 300px;">
                          <div class="d-flex align-items-center justify-content-between">
                            <!-- Show display text only when not editing -->
                            <span v-if="!(
                              isEditingRole[field.name] &&
                              isEditingRole[field.name][roleKey]
                            ) && (
                                roleKey === 'prepared_by' ||
                                roleKey === 'verified_by' ||
                                roleKey === 'approved_by'
                              )">
                              {{ formatRoleName(roleKey) }}
                            </span>
                            <!-- Optional fallback for dynamic roles -->
                            <span v-else-if="!roleOptions.find(opt => opt.id === roleKey)" style="color:red">
                              Click edit icon to add
                            </span>

                            <!-- Edit, Add, and Remove Icons -->
                            <div class="d-flex"
                              v-if="!isEditingRole[field.name] || !isEditingRole[field.name][roleKey]">

                              <i v-if="!usersubgroup_id" class="fas fa-edit text-info ml-2" style="cursor: pointer; 
                          font-size: 14px!important;margin-right: 10px;"
                                @click.stop="enableRoleEditing(field.name, roleKey)">
                              </i>
                              <i v-if="!usersubgroup_id" class="fas fa-plus-square text-success ml-2" style="cursor: pointer; 
                          font-size: 14px!important;margin-right: 10px;"
                                @click="addSignatureField(field.name, roleKey)">
                              </i>
                              <i v-if="!usersubgroup_id" class="fas fa-minus-circle text-danger ml-2" style="cursor: pointer; 
                          font-size: 14px!important;margin-right: 50px;"
                                @click="removeNewRoleAndSignatureField(field.name, roleKey)">

                              </i>
                            </div>
                          </div>

                          <!-- Show select box for role when in edit mode -->
                          <div v-if="isEditingRole[field.name] && isEditingRole[field.name][roleKey]"
                            class="d-flex align-items-center mt-2">
                            <b-form-select v-model="selectedRole[field.name][roleKey]" :options="roleOptions"
                              value-field="id" text-field="name" style="width: 250px;" class="mr-2">
                            </b-form-select>
                            <button class="btn btn-success btn-sm" @click="updateRole(field.name, roleKey)">
                              Update
                            </button>
                            <button class="btn btn-danger btn-sm" @click="cancelUpdateRole(field.name, roleKey)">
                              Cancel
                            </button>
                          </div>
                        </td>
                        <td>
                          <!-- Officials under this role -->
                          <div v-for="(official, idx) in role" :key="idx" class="d-flex flex-column">
                            <div
                              v-if="!isEditing[field.name] || !isEditing[field.name][roleKey] || !isEditing[field.name][roleKey][idx]"
                              class="d-flex align-items-center justify-content-between">
                              <span v-if="official">{{ getSignatureName(official) }}</span>
                              <span v-else style="color:red">Click edit icon to add</span>

                              <div class="d-flex">
                                <!-- Edit Icon -->
                                <i v-if="!usersubgroup_id" class="fas fa-edit text-info ml-2"
                                  style="cursor: pointer; font-size: 14px!important; margin-right: 10px;"
                                  @click.stop="enableEditing(field.name, roleKey, idx)">
                                </i>

                                <!-- Minus/Delete Icon -->
                                <i v-if="!usersubgroup_id" class="fas fa-minus-circle text-danger ml-2"
                                  style="cursor: pointer; font-size: 14px!important;"
                                  @click="removeOfficial(field.name, roleKey, idx)">
                                </i>
                              </div>

                            </div>

                            <!-- Official Select Box -->
                            <div v-if="isEditing[field.name] &&
                              isEditing[field.name][roleKey] &&
                              isEditing[field.name][roleKey][idx]" class="d-flex align-items-center mt-2">
                              <b-form-select v-model="field.signed_officials[roleKey][idx]" :options="signatureOptions"
                                value-field="id" text-field="name" style="width: 250px;" class="mr-2">
                              </b-form-select>
                              <button class="btn btn-success btn-sm"
                                @click="updateOfficial(field.name, roleKey, idx)">Update</button>
                              <button class="btn btn-danger btn-sm"
                                @click="cancelEditOfficial(field.name, roleKey)">Cancel</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </b-form-group>
    </b-row>

    <b-row style="margin: 5px;">
      <b-form-group>
        <label style="font-weight: bold;">
          3. Activity Question Paper Mapping
        </label>

        <div style="display: flex; flex-direction: column; margin-top: 10px;">

          <!-- CO -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralCo"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Course Outcome (CO) mapping in activity question paper</span>
          </div>

          <!-- PO -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralPo"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Programme Outcome (PO) mapping in activity question paper</span>
          </div>

          <!-- PSO -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralPso"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Programme Specific Outcome (PSO) mapping in activity question paper</span>
          </div>

          <!-- ML -->
          <div style="display: flex; align-items: center; margin-bottom: 6px;">
            <input
              type="checkbox"
              v-model="displayOnlyNumeralMl"
              :disabled="!editDisplayOnlyNumeral"
              style="margin-right: 10px; width: 18px; height: 18px; cursor: pointer;"
            />
            <span>Display only numeral for Module (ML) mapping in activity question paper</span>
          </div>
        </div>

        <!-- Common Actions -->
        <div style="margin-top: 10px;">
          <button
            v-if="editDisplayOnlyNumeral"
            class="btn btn-success btn-sm mr-2"
            @click="updateAllDisplayOnlyNumeral"
          >
            Update
          </button>

          <button
            v-if="editDisplayOnlyNumeral"
            class="btn btn-danger btn-sm mr-2"
            @click="cancelEditDisplayOnlyNumeral"
          >
            Cancel
          </button>

          <i
            v-if="!editDisplayOnlyNumeral && !usersubgroup_id"
            class="fas fa-edit text-info"
            style="font-size: 15px !important; cursor: pointer;"
            @click="enableDisplayOnlyNumeralEdit"
          ></i>
        </div>
      </b-form-group>
    </b-row>

    <b-row style="margin: 5px;">
      <div class="card p-4" style="width: 90%;">
        <label style="font-weight: bold;">
          4. Question Paper Template
        </label>
        <div>
          <button class="btn btn-primary" @click="showCreateTemplateModal = true">Create Template</button>
        </div>

        <!-- Delete Confirmation Modal -->
        <b-modal v-model="showDeleteConfirmModal" title="Confirm Delete" hide-footer>
          <p>Type <strong>DELETE</strong> to confirm deletion of <strong>{{ templateToDelete && templateToDelete.name }}</strong>.</p>
          <b-form-input v-model="deleteConfirmText" placeholder="Type DELETE here" class="mb-3"></b-form-input>
          <p class="text-danger">This action will permanently delete this template and all associated questions. This cannot be undone.</p>
          <div class="d-flex justify-content-end">
            <button class="btn btn-secondary mr-2" @click="showDeleteConfirmModal = false; deleteConfirmText = ''">Cancel</button>
            <button class="btn btn-danger" :disabled="deleteConfirmText !== 'DELETE'" @click="confirmDeleteTemplate">Delete</button>
          </div>
        </b-modal>

        <!-- Create / Edit Template Modal -->
        <b-modal v-model="showCreateTemplateModal" :title="editingTemplate ? 'Edit Template' : 'Create Template'" hide-footer>
          <b-form @submit.prevent="submitCreateTemplate">
            <b-form-group label="Name" label-for="template-name">
              <b-form-input
                id="template-name"
                v-model="newTemplate.name"
                placeholder="Enter template name"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Description" label-for="template-description">
              <b-form-textarea
                id="template-description"
                v-model="newTemplate.summary"
                placeholder="Enter description"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-secondary mr-2" @click="showCreateTemplateModal = false; editingTemplate = null; newTemplate = { name: '', summary: '' }">Cancel</button>
              <button type="submit" class="btn btn-primary">{{ editingTemplate ? 'Update' : 'Create' }}</button>
            </div>
          </b-form>
        </b-modal>
        <table class="table table-striped table-bordered mt-2">
          <thead class="thead-dark text-left">
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th></th>
              <th></th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loadingTemplates">
              <td colspan="3" class="text-center py-3">
                <b-spinner small></b-spinner> Loading...
              </td>
            </tr>
            <template v-else-if="templates && templates.length">
              <tr v-for="(template, key) in templates" :key="key">
                <td>{{ template.name }}</td>
                <td>{{ template.summary }}</td>
                <td><b-link @click="openManageExamQuestions(template)">Edit Template</b-link></td>
                <td>
                  <b-link @click="downloadTemplate(template,true)">View</b-link>
                  <!-- <b-link @click="downloadTemplate(template,false)">Download</b-link> -->
                </td>
                <td class="p-2">
                  <i class="fas fa-edit mx-2 text-info" style="cursor: pointer;" @click="openEditTemplateModal(template)"></i>
                  <i class="fas fa-trash text-danger mx-2" style="cursor: pointer;" @click="deleteTemplate(template)"></i>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="3" class="text-center">No Templates to show.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-row>

    <b-row style="margin: 5px;">
      <div class="p-4 card" style="width: 90%;">
        <div>
          <b>5. Question Paper Design</b>
          <i v-if="!usersubgroup_id" style="cursor: pointer; margin-left: 10px; font-size: 16px !important; color: #1ea2ed;" class="fas fa-edit"
            @click="toggleHeaderEdit"></i>
          <br />
        </div>

        <!-- Radio buttons below title -->
        <div v-if="isloadingHeader">
          <b-spinner small></b-spinner> Loading...
        </div>
        <div class="mt-2" v-else>
          <b-form-group
            label="Select Header Template:"
            label-cols-sm="12"
            label-size="sm"
            class="mt-2"
          
          >
            <b-form-radio
              v-model="header_template"
              :value="1"
              :disabled="!isHeaderDesignEditing"
            >
            <p>Design 1</p>
            </b-form-radio>

            <div v-if="header_template === 1" class="p-2">
              <table style="text-align: center;" width="50%" class="table table-bordered">
                <tbody>
                    <tr>
                        <td >Logo</td>
                        <td colspan="2"><strong>College of Engineering Demo</strong><br>
                        Sub Heading</td>
                    </tr>
                    <tr>
                    <td >variable_issueNo</td>
                    <td rowspan="2"><strong>Question Paper</strong></td>
                    <td rowspan="2">EEE-24</td>
                    </tr>
                    <tr>
                    <td >variable_revisionNo</td>
                    </tr>
                    <tr>
                    <td colspan="2">B. TECH ELECTRICAL & ELECTRONIC ENGG</td>
                    <td >Department of Electrical & Electronics Engineering</td>
                    </tr>
                    <tr>
                    <td colspan="2">class test for student</td>
                    <td >Academic Year:  2022-23</td>
                    </tr>
                    <tr>
                    <td >Course Code: JL 120</td>
                    <td >L-T-P Credits: 0-0-2-1</td>
                    <td >Course Name: Java</td>
                    </tr>
                </tbody>
            </table>
          </div>
          <hr>
            <b-form-radio
              v-model="header_template"
              :value="2"
              :disabled="!isHeaderDesignEditing"
            >
            <p>Design 2</p>
            </b-form-radio>
          </b-form-group>

          <div v-if="header_template === 2" class="p-2">
              <table width="50%" style="text-align: center;" class="table table-borderless">
                <tbody style="font-family: Lucida;">                    
                    <tr style="border: none !important;">
                        <td colspan="100%">
                            <div style="width: 60%; margin: auto; font-family: Lucida; font-size: 28px !important; font-style: italic;">B.Tech Degree II Semester Model Question Paper in Instrumentation and Control Engineering April 2027</div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="100%" style="font-weight: bold !important; font-family: Lucida;">26-219-0202 ENGINEERING CHEMISTRY</td>
                    </tr>
                    <tr>
                        <td colspan="100%" style="font-weight: normal;">(2026 Scheme)</td>
                    </tr>
                    <tr>
                        <td colspan="100%" style="font-weight: normal;">(2026 Admission)</td>
                    </tr>
                </tbody>
            </table>
          </div>

          <b-button variant="info" class="m-2" @click="setHeaderDesign()"
          :disabled="!isHeaderDesignEditing">Update</b-button>
        </div>
      </div>
    </b-row>    

    <!-- ManageExamQuestions full screen overlay -->
    <div v-if="showManageExamQuestions" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: #fff; z-index: 9999; overflow-y: auto;">
      <div class="p-2">
        <button class="btn btn-danger btn-sm float-right" @click="showManageExamQuestions = false">Close</button>
      </div>
      <manageQuestionsTemplate :exam="selectedTemplate" />
    </div>
  </div>

</template>

<script>
import manageQuestionsTemplate from "../examination/manageQuestionsTemplate.vue";

export default {
  components: { manageQuestionsTemplate },
  props: ["group_id", "usergroup_id", "usersubgroup_id"],
  async created() {
    this.loadingTemplates = true;
    this.isloadingHeader = true;
    await this.getQuestionPaperZoomLevel();
    await this.getQuestionPaperSignatureFieldSigningOfficials();
    await this.loadDisplayOnlyNumeralSettings();
    await this.getHeaderDesign();
    await this.getQuestionPaperTemplates();
  },
  data() {
    return {
      showManageExamQuestions: false,
      selectedTemplate: null,
      showCreateTemplateModal: false,
      editingTemplate: null,
      newTemplate: { name: '', summary: '' },
      showDeleteConfirmModal: false,
      templateToDelete: null,
      deleteConfirmText: '',
      loadingTemplates: false,
      templates: {},
      displayOnlyNumeralCo: false,
      displayOnlyNumeralPo: false,
      displayOnlyNumeralPso: false,
      displayOnlyNumeralMl: false,
      editDisplayOnlyNumeral: false,
      backupDisplayOnlyNumeral: {}, // store backup values for cancel
      backupOfficialValues: {},
      backupRoleKeys: {},
      previousZoomLevel: null,
      editZoomLevel: false,
      zoomOptions: [
        { value: 1.00, text: '1.00' },
        { value: 1.25, text: '1.25' },
        { value: 1.3, text: '1.3' },
        { value: 1.35, text: '1.35' },
        { value: 1.4, text: '1.4' },
        { value: 1.45, text: '1.45' },
        { value: 1.5, text: '1.5' },
      ],
      zoomLevel: 1.3,
      isEditing: {},
      // Options for the signature select dropdown
      signatureOptions: [
        { id: 'course_in_charge', name: 'Course-in-Charge' },
        { id: 'advisor', name: 'Advisor' },
        { id: 'HOD', name: 'HOD' },
        { id: 'DQAC', name: 'DQAC' },
        { id: 'principal', name: 'Principal' },
        { id: 'IQAC', name: 'IQAC' },
        { id: 'stream_coordinator', name: 'Stream Coordinator' }
      ],
      // Updated signatureFields: each official field is now an array
      signatureFields: [],
      isEditingRole: {},  // Object to track role edit mode
      selectedRole: {},    // Store the selected role during editing
      roleOptions: [
        { id: 'prepared_by', name: 'Prepared By' },
        { id: 'verified_by', name: 'Verified By' },
        { id: 'approved_by', name: 'Approved By' },
      ],
      isHeaderDesignEditing: false,
      header_template: 1,
      isloadingHeader: false,
    };
  },
  computed: {
    // Returns the display name for a given signature id.
    getSignatureName() {
      return (id) => {
        const option = this.signatureOptions.find(option => option.id === id);
        return option ? option.name : id;
      };
    }
  },
  methods: {
    async downloadTemplate(template, viewReport){

      const url =
        this.$store.getters.getAPIKey.mainAPI + `/exams/templates/pdfexport`;
      await this.$axios
        .post(url, {exam_id: template.id}, { responseType: "blob" })
        .then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const pdfUrl = window.URL.createObjectURL(pdfBlob);
          let newTab = null;
          if (viewReport) {
            newTab = window.open(pdfUrl, "_blank");
          }
          if (!newTab) {
            if (viewReport)
              this.$toast.error(
                "Failed to show pdf file, insted the file will be downloaded",
                {
                  position: "top",
                  duration: 3000,
                }
              );
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download",`${template.name}.pdf` )
            document.body.appendChild(link);
            link.click();
            link.remove();
          }

          // console.log(response);
        })
        .catch((error) => {
          let errorText = "Failed to Download, please check connectivity";
          if (error.response != undefined)
            errorText =
              error.response.status == 422
                ? "Custom report is not configured by admin"
                : "Failed to Download, please try again";
          this.$toast.error(errorText, {
            position: "top",
            duration: 3000,
          });
        });
    },
    openEditTemplateModal(template) {
      this.editingTemplate = template;
      this.newTemplate = { name: template.name, summary: template.summary };
      this.showCreateTemplateModal = true;
    },
    openManageExamQuestions(template) {
      this.selectedTemplate = template;
      this.showManageExamQuestions = true;
    },
    deleteTemplate(template) {
      this.templateToDelete = template;
      this.deleteConfirmText = '';
      this.showDeleteConfirmModal = true;
    },
    async confirmDeleteTemplate() {
      if (this.deleteConfirmText !== 'DELETE') return;
      this.showDeleteConfirmModal = false;
      const url = this.$store.getters.getAPIKey.mainAPI + `/exams/${this.templateToDelete.id}`;
      await this.$axios
        .delete(url)
        .then(async () => {
          this.$toast.success("Template deleted successfully", { position: "top", duration: 3000 });
          await this.deleteTemplateQuestions();
          this.templateToDelete = null;
          this.deleteConfirmText = '';
          this.getQuestionPaperTemplates();
        })
        .catch((error) => {
          const msg = error.response?.data?.message || "Failed to delete template";
          this.$toast.error(msg, { position: "top", duration: 3000 });
        });
    },
    async deleteTemplateQuestions(){
      const url = this.$store.getters.getAPIKey.mainAPI + `/examquestions/delete`;
      await this.$axios
        .delete(url, { data: { exam_id: this.templateToDelete.id } })
        .then(() => {
          this.$toast.success("Template questions deleted successfully", { position: "top", duration: 3000 });
        })
        .catch((error) => {
          const status = error.response?.status;
          const msg = status === 401 || status === 403
            ? "You are not authorised to delete this template"
            : error.response?.data?.message || "Failed to delete questions";
          this.$toast.error(msg, { position: "top", duration: 3000 });
        });
    },
    async submitCreateTemplate() {
      const isEdit = !!this.editingTemplate;
      const payload = {
        ...this.newTemplate,
        is_template: true,
        config_group_id: this.group_id,
      };
      this.showCreateTemplateModal = false;

      let url = isEdit
        ? `${this.$store.getters.getAPIKey.mainAPI}/exams/${this.editingTemplate.id}`
        : this.$store.getters.getAPIKey.examination;

      let status = null;
      await this.$axios[isEdit ? 'put' : 'post'](url, payload)
        .then(() => {
          status = true;
          this.$toast.success(isEdit ? "Template updated successfully" : "Template created successfully", { position: "top", duration: 3000 });
          this.editingTemplate = null;
          this.newTemplate = { name: '', summary: '' };
          this.getQuestionPaperTemplates();
        })
        .catch((error) => {
          let errortxt = isEdit ? "Failed to update template" : "Failed to create template";
          if (error.response?.status == 422) {
            const errormsgs = error.response.data.errors;
            errortxt = errormsgs[Object.keys(errormsgs)[0]][0];
          } else {
            errortxt = error.response?.data?.message || errortxt;
          }
          this.$toast.error(errortxt, { position: "top", duration: 3000 });
          status = false;
        });
      return status;
    },

    async loadDisplayOnlyNumeralSettings() {
      try {
        const [coRes, poRes, psoRes, mlRes] = await Promise.all([
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_co`),
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_po`),
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_pso`),
          this.$axios.get(`${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_ml`),
        ]);

        this.displayOnlyNumeralCo = coRes.data == 1;
        this.displayOnlyNumeralPo = poRes.data == 1;
        this.displayOnlyNumeralPso = psoRes.data == 1;
        this.displayOnlyNumeralMl = mlRes.data == 1;
      } catch (e) {
        // fallback defaults
        this.displayOnlyNumeralCo = false;
        this.displayOnlyNumeralPo = false;
        this.displayOnlyNumeralPso = false;
        this.displayOnlyNumeralMl = false;
      }
    },

    enableDisplayOnlyNumeralEdit() {
      this.backupDisplayOnlyNumeral = {
        co: this.displayOnlyNumeralCo,
        po: this.displayOnlyNumeralPo,
        pso: this.displayOnlyNumeralPso,
        ml: this.displayOnlyNumeralMl,
      };
      this.editDisplayOnlyNumeral = true;
    },

    cancelEditDisplayOnlyNumeral() {
      this.displayOnlyNumeralCo = this.backupDisplayOnlyNumeral.co;
      this.displayOnlyNumeralPo = this.backupDisplayOnlyNumeral.po;
      this.displayOnlyNumeralPso = this.backupDisplayOnlyNumeral.pso;
      this.displayOnlyNumeralMl = this.backupDisplayOnlyNumeral.ml;
      this.editDisplayOnlyNumeral = false;
    },

    async updateAllDisplayOnlyNumeral() {
      try {
        await Promise.all([
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_co`,
            { display_only_numeral_co: this.displayOnlyNumeralCo }
          ),
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_po`,
            { display_only_numeral_po: this.displayOnlyNumeralPo }
          ),
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_pso`,
            { display_only_numeral_pso: this.displayOnlyNumeralPso }
          ),
          this.$axios.post(
            `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/display_only_numeral_ml`,
            { display_only_numeral_ml: this.displayOnlyNumeralMl }
          ),
        ]);
        this.$toast.success("Updated Display Only Numeral Settings", {
          position: "top",
          duration: 3000,
        });
        this.editDisplayOnlyNumeral = false;
      } catch (e) {
        this.$toast.error("Failed to update settings", {
          position: "top",
          duration: 3000,
        });
      }
    },

    enableZoomEdit() {
      this.previousZoomLevel = this.zoomLevel; // Save original value
      this.editZoomLevel = true;
    },
    cancelEditZoomLevel() {
      this.zoomLevel = this.previousZoomLevel; // Revert to original
      this.editZoomLevel = false;
    },
    addSignatureField(fieldName, roleKey) {
      const field = this.signatureFields.find(field => field.name === fieldName);

      if (field) {
        // Ensure signed_officials exists
        if (!field.signed_officials[roleKey]) {
          this.$set(field.signed_officials, roleKey, []);
        }

        // Add a new empty role (null)
        field.signed_officials[roleKey].push(null);
        this.$forceUpdate();
      }
    },
    addNewRoleAndSignatureField(name) {
      const field = this.signatureFields.find(f => f.name === name);
      if (!field) return;

      // Fix if signed_officials is missing or not an object
      if (
        !field.signed_officials ||
        typeof field.signed_officials !== 'object' ||
        Array.isArray(field.signed_officials)
      ) {
        this.$set(field, 'signed_officials', {});
      }

      // Count existing dynamic new_X keys
      const newKeys = Object.keys(field.signed_officials).filter(key => key.startsWith('new_'));
      if (newKeys.length >= 4) {
        alert('Maximum limit of 4 additional signed officials reached.');
        return;
      }

      // Add the first available new_X key
      for (let i = 1; i <= 4; i++) {
        const key = `new_${i}`;
        if (!(key in field.signed_officials)) {
          this.$set(field.signed_officials, key, [null]); // Add with default string value
          this.$forceUpdate();
          return;
        }
      }
    },

    removeNewRoleAndSignatureField(name, index) {
      const field = this.signatureFields.find(field => field.name === name);
      if (!field) return;
      delete field.signed_officials[index];
      this.setQuestionPaperSignatureFieldSigningOfficials(name, field.signed_officials);
      this.$forceUpdate();
    },

    removeOfficial(fieldName, roleKey, idx) {
      const field = this.signatureFields.find(f => f.name === fieldName);
      if (!field || !field.signed_officials[roleKey]) return;

      // Remove the official at the specific index
      field.signed_officials[roleKey].splice(idx, 1);

      // Save the updated list
      this.setQuestionPaperSignatureFieldSigningOfficials(fieldName, field.signed_officials);
    },

    enableRoleEditing(fieldName, roleKey) {
      // Initialize editing tracker
      if (!this.isEditingRole[fieldName]) {
        this.$set(this.isEditingRole, fieldName, {});
      }
      this.$set(this.isEditingRole[fieldName], roleKey, true);

      // Initialize selectedRole
      if (!this.selectedRole[fieldName]) {
        this.$set(this.selectedRole, fieldName, {});
      }

      // Set default selected value
      this.selectedRole[fieldName][roleKey] = roleKey;

      // Backup original roleKey
      if (!this.backupRoleKeys[fieldName]) {
        this.$set(this.backupRoleKeys, fieldName, {});
      }

      this.$set(this.backupRoleKeys[fieldName], roleKey, roleKey);
    },

    cancelUpdateRole(fieldName, roleKey) {
      if (!this.isEditingRole[fieldName]) return;

      // Revert roleKey to the backed-up original
      const originalRoleKey = this.backupRoleKeys?.[fieldName]?.[roleKey];

      if (originalRoleKey && roleKey !== originalRoleKey) {
        const field = this.signatureFields.find(f => f.name === fieldName);
        if (field && field.signed_officials[roleKey]) {
          // Move data back
          this.$set(field.signed_officials, originalRoleKey, field.signed_officials[roleKey]);
          this.$delete(field.signed_officials, roleKey);
        }
      }

      // Exit editing mode
      this.$set(this.isEditingRole[fieldName], roleKey, false);

      // Clean backup
      if (this.backupRoleKeys[fieldName]) {
        this.$delete(this.backupRoleKeys[fieldName], roleKey);
      }
    },

    updateRole(fieldName, roleKey) {
      let newRole = this.selectedRole[fieldName][roleKey];

      let field = this.signatureFields.find(f => f.name === fieldName);

      if (field && field.signed_officials[roleKey]) {
        const updatedSignedOfficials = {};

        Object.keys(field.signed_officials).forEach((key) => {
          if (key === roleKey) {
            updatedSignedOfficials[newRole] = field.signed_officials[roleKey];
          } else {
            updatedSignedOfficials[key] = field.signed_officials[key];
          }
        });

        field.signed_officials = updatedSignedOfficials;

        // Clear the editing state only for the updated role
        if (this.isEditingRole[fieldName]) {
          this.$set(this.isEditingRole[fieldName], roleKey, false);
          this.$set(this.selectedRole[fieldName], roleKey, null);
        }

        this.setQuestionPaperSignatureFieldSigningOfficials(fieldName, field.signed_officials);
      }
    },
    updateOfficial(fieldName, roleKey, idx) {
      // Get the specific field
      const field = this.signatureFields.find(f => f.name === fieldName);
      if (!field || !field.signed_officials[roleKey]) return;

      // Optional: Validate or process the updated official value if needed

      // Clear edit state only for the specific official
      if (this.isEditing[fieldName] &&
        this.isEditing[fieldName][roleKey] &&
        this.isEditing[fieldName][roleKey][idx] !== undefined) {
        this.$set(this.isEditing[fieldName][roleKey], idx, false);
      }

      this.setQuestionPaperSignatureFieldSigningOfficials(fieldName, field.signed_officials);
    },

    formatRoleName(roleKey) {
      const roleMap = {
        prepared_by: "Prepared By",
        verified_by: "Verified By",
        approved_by: "Approved By",
      };
      return roleMap[roleKey] || roleKey;
    },
    formatFieldName(name) {
      return name
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },

    // Enable edit mode for a specific role in a field.
    enableEditing(fieldName, roleKey, index) {
      if (!this.isEditing[fieldName]) {
        this.$set(this.isEditing, fieldName, {});
      }

      if (!this.isEditing[fieldName][roleKey]) {
        this.$set(this.isEditing[fieldName], roleKey, {});
      }

      // Clear previous index states under this roleKey
      Object.keys(this.isEditing[fieldName][roleKey]).forEach(i => {
        this.$set(this.isEditing[fieldName][roleKey], i, false);
      });

      this.$set(this.isEditing[fieldName][roleKey], index, true);

      // Backup original value
      if (!this.backupOfficialValues[fieldName]) {
        this.$set(this.backupOfficialValues, fieldName, {});
      }
      if (!this.backupOfficialValues[fieldName][roleKey]) {
        this.$set(this.backupOfficialValues[fieldName], roleKey, {});
      }

      const originalValue = this.signatureFields
        .find(f => f.name === fieldName)
        .signed_officials[roleKey][index];

      this.$set(this.backupOfficialValues[fieldName][roleKey], index, originalValue);
    },

    cancelEditOfficial(fieldName, roleKey) {
      if (
        this.isEditing[fieldName] &&
        this.isEditing[fieldName][roleKey] &&
        this.backupOfficialValues[fieldName] &&
        this.backupOfficialValues[fieldName][roleKey]
      ) {
        const field = this.signatureFields.find(f => f.name === fieldName);
        const role = field?.signed_officials[roleKey];

        if (Array.isArray(role)) {
          Object.keys(this.isEditing[fieldName][roleKey]).forEach(index => {
            if (this.backupOfficialValues[fieldName][roleKey][index] !== undefined) {
              this.$set(
                field.signed_officials[roleKey],
                index,
                this.backupOfficialValues[fieldName][roleKey][index]
              );
            }

            this.$set(this.isEditing[fieldName][roleKey], index, false);
          });
        }
      }
    },

    async getQuestionPaperSignatureFieldSigningOfficials() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups/questionpapersignaturefield?
      usergroup_id=${this.usergroup_id}&group_id=${this.group_id}`;
      try {
        const response = await this.$axios.get(url);
        if (response.data) {
          this.signatureFields = response.data;
        }
      } catch (error) {
        console.error("Error fetching signature field data:", error);
      }
    },
    getQuestionPaperZoomLevel() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups-configuration-groups/setting/${this.group_id}/question_paper_zoom_level`;
      this.$axios
        .get(url)
        .then((response) => {
          this.zoomLevel = parseFloat(response.data) || 1.3;
        })
        .catch(() => {
          this.zoomLevel = 1.3;
        });
    },

    getQuestionPaperTemplates() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/exams/templates/question-paper?config_group_id=${this.group_id}`;
      this.loadingTemplates = true;
      this.$axios
        .get(url)
        .then((response) => {
          this.templates = response.data;
        })
        .catch((error) => {
          console.error("Error fetching templates:", error);
        })
        .finally(() => {
          this.loadingTemplates = false;
        });
    },

    async setQuestionPaperSignatureFieldSigningOfficials(report_name, signedOfficials) {
      try {
        const url =
          this.$store.getters.getAPIKey.mainAPI +
          `/usergroups/questionpapersignaturefield?usergroup_id=${this.usergroup_id}`;
        await this.$axios.post(url, {
          usergroup_id: this.usergroup_id,
          report_name: report_name,
          signed_officials: signedOfficials,
          group_id: this.group_id
        });

        this.$toast.success("Updated Question Paper Signature Field Settings", {
          position: "top",
          duration: 3000,
        });

      } catch (error) {
        this.$toast.error("Failed to update settings", { position: "top", duration: 3000 });
        console.error("Error updating signature field settings:", error);
      }
    },

    async setQuestionPaperZoomLevel() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/usergroups-configuration-groups/setting/${this.group_id}/question_paper_zoom_level`;
      await this.$axios
        .post(url, { question_paper_zoom_level: this.zoomLevel })
        .then(() => {
          this.editZoomLevel = false;
          this.$toast.success("Updated Question Paper Zoom Level", {
            position: "top",
            duration: 3000,
          });
        });
    },

    toggleHeaderEdit(){
      this.isHeaderDesignEditing = !this.isHeaderDesignEditing;
      if (!this.isHeaderDesignEditing) {
        // Reset the selection if the user exits edit mode
        this.getHeaderDesign();
      }
    },

    async setHeaderDesign(){

      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/header_template_design`;
        await this.$axios.post(url, { header_template_design: this.header_template });
        this.$toast.success("Updated", { position: "top", duration: 3000 });
        this.isHeaderDesignEditing = false; // Disable edit mode after update
      } catch (error) {
        console.error("Error updating header configuration:", error);
        this.$toast.error("Update failed!", { position: "top", duration: 3000 });
      }

    },

    async getHeaderDesign() {
      this.isloadingHeader = true;
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/usergroups-configuration-groups/setting/${this.group_id}/header_template_design`;
        const response = await this.$axios.get(url);
        const value = parseInt(response.data);
        this.header_template = isNaN(value) ? 1 : value;

      } catch (error) {
        console.error("Error fetching header configuration:", error);

      } finally {
        this.isloadingHeader = false;
      }
    },

  },
};
</script>
